












































































































































import { Vue, Component, Watch, Prop, Model, Provide } from "vue-property-decorator";
import * as d3 from "../ts/d3";
import { flextree } from "d3-flextree";
import ImData from "../ts/ImData";
import History from "../ts/History";
import toMarkdown from "../ts/toMarkdown";
import Silder from "./Silder.vue";
import Clipboard from "vue-clipboard2";
import html2canvas from "html2canvas";
// import { saveAs } from "file-saver";
let mmdata: ImData; // 思维导图数据
// const preset = presets.offscreen();
// @Component
@Component({ components: { Silder } })
export default class MindMap extends Vue {
  @Prop() width: number | undefined;
  @Prop() height: number | undefined;
  @Prop({ default: 50 }) xSpacing!: number;
  @Prop({ default: 10 }) ySpacing!: number;
  @Prop({ default: true }) draggable!: boolean;
  @Prop({ default: true }) gps!: boolean;
  @Prop({ default: true }) fitView!: boolean;
  @Prop({ default: true }) download!: boolean;
  @Prop({ default: true }) keyboard!: boolean;
  @Prop({ default: true }) showNodeAdd!: boolean;
  @Prop({ default: true }) contextMenu!: boolean;
  @Prop({ default: true }) zoomable!: boolean;
  @Prop({ default: true }) showUndo!: boolean;
  @Prop({ default: 4 }) strokeWidth!: number;
  @Prop({ default: false }) viewMode!: boolean;
  @Prop({ default: true }) showBack!: boolean;
  @Prop({ default: false }) zoomFit!: boolean;
  @Prop({ default: false }) zoomMode!: boolean;
  @Prop({
    default: () => {
      return {};
    },
  })
  power!: Object;
  @Model("change", { required: true }) value!: Array<Data>;

  @Watch("keyboard")
  onKeyboardChanged(val: boolean) {
    this.makeKeyboard(val);
  }
  @Watch("showNodeAdd")
  onShowNodeAddChanged(val: boolean) {
    this.makeNodeAdd(val);
  }
  @Watch("draggable")
  onDraggableChanged(val: boolean) {
    this.makeDrag(val);
  }
  @Watch("contextMenu")
  onContextMenuChanged(val: boolean) {
    this.makeContextMenu(val);
  }
  @Watch("xSpacing")
  onXSpacingChanged() {
    mmdata.resize();
    this.updateMmdata();
    this.updateMindmap();
  }
  @Watch("ySpacing")
  onYSpacingChanged() {
    this.updateMindmap();
  }
  @Watch("zoomable")
  onZoomableChanged(val: boolean) {
    this.makeZoom(val);
  }

  $refs!: {
    mindmap: HTMLDivElement;
    svg: Element;
    content: Element;
    dummy: HTMLDivElement;
    menu: HTMLDivElement;
    selectedBox: SVGRectElement;
  };

  dragFlag = false;
  multiSeleFlag = false;
  minTextWidth = 30;
  minTextHeight = 21;
  gBtnSide = 24; // gBtn边长
  foreignBorderWidth = 3;
  spaceKey = false;
  toRecord = true; // 判断是否需要记录mmdata的数据快照
  toUpdate = true; // 判断是否需要更新mmdata
  dTop!: FlexNode; // mmdata中纵坐标最高的数据
  root!: FlexNode; // 包含位置信息的mmdata
  showContextMenu = false;
  showPopUps = false;
  showSelectedBox = false; // 选中框
  contextMenuX = 0;
  contextMenuY = 0;
  showResizeButton = false;
  resizeButtonY = 0;
  resizeButtonX = 0;
  reiszeBufferWidth = 0;
  reiszeBufferHeight = 0;
  resizeBufferPageX = 0;
  resizeData!: Mdata;
  multiple = 1;
  copyNodeData: Mdata[] = [];
  mouse = { x0: 0, y0: 0, x1: 0, y1: 0 };
  contextMenuTarget!: Mdata | Mdata[];
  contextMenuItems = [
    { title: "新建上级", name: "add_parent", disabled: false },
    { title: "新建子类", name: "add", disabled: false },
    { title: "新建同级", name: "add_brother", disabled: false },
    { title: "删除节点", name: "delete", disabled: false },
    { title: "仅删除自己", name: "delete_single", disabled: false },
    { title: "折叠节点", name: "collapse", disabled: false },
    { title: "展开节点", name: "expand", disabled: false },
    { title: "折叠全部节点", name: "collapse_all", disabled: false },
    { title: "展开全部节点", name: "expand_all", disabled: false },
  ];
  optionList = [
    {
      title: "JSON",
      icon: "code-json",
      tip: "创建一个JSON格式的文本文件",
      color: "purpleOpt",
    },
    {
      title: "图像",
      icon: "image",
      tip: "创建一个PNG格式的图像文件",
      color: "greenOpt",
      disabled: true,
    },
    {
      title: "Markdown",
      icon: "markdown",
      tip: "创建一个Markdown格式的文本文件",
      color: "grassOpt",
    },
  ];
  selectedOption = 0;
  mindmapSvg!: d3.Selection<Element, FlexNode, null, undefined>;
  mindmapG!: d3.Selection<Element, FlexNode, null, undefined>;
  dummy!: d3.Selection<HTMLDivElement, FlexNode, null, undefined>;
  mindmapSvgZoom!: d3.ZoomBehavior<Element, FlexNode>;
  easePolyInOut = d3.transition().duration(1000).ease(d3.easePolyInOut);
  link = d3
    .linkHorizontal()
    .x((d) => d[0])
    .y((d) => d[1]);
  zoom = d3.zoom() as d3.ZoomBehavior<Element, FlexNode>;
  history = new History();
  init_per = 0;
  // singleSelect = {}
  isSelectNode = false;
  isSelectNodeUnderline = "";
  showColorList = false;
  selectNodeColor = "#C2C2C2";
  colorList = [
    "#6D6D6D",
    "#f19b66",
    "#85c7f9",
    "#a358c2",
    "#f8ce5a",
    "#ed696d",
    "#7dc6cc",
    "#fffeff",
    "#d17e4c",
    "#65a7d9",
    "#8e44ac",
    "#d2ab3b",
    "#d15057",
    "#5fa6ad",
    "#a6a6a5",
    "#9b5024",
    "#3174a4",
    "#6c238b",
    "#937424",
    "#a22234",
    "#32757c",
    "#595a59",
    "#561307",
    "#12375f",
    "#400d5f",
    "#48300b",
    "#650f08",
    "#13373d",
    "#000000",
    "#FF5E69",
  ];
  saveTimer = -1;

  sizeMethod = {};

  get mmStyle() {
    return {
      width: this.width ? `${this.width}px` : "100%",
      height: this.height ? `${this.height}px` : "",
    };
  }
  get svgClass() {
    return `stroke-width-${this.strokeWidth} ${
      this.spaceKey && this.zoomable ? "grab" : ""
    }`;
  }
  get optionTip() {
    return this.optionList[this.selectedOption].tip;
  }
  get canUndo() {
    return this.history.canUndo;
  }
  get canRedo() {
    return this.history.canRedo;
  }
  get seleBox() {
    const { x0, x1, y0, y1 } = this.mouse;
    const x = Math.min(x0, x1);
    const y = Math.min(y0, y1);
    const width = Math.abs(x0 - x1);
    const height = Math.abs(y0 - y1);
    return { x, y, width, height, left: x, top: y, right: x + width, bottom: y + height };
  }

  getViewPos(p?: DOMRect) {
    const svgPos = this.$refs.svg.getBoundingClientRect();
    const { pageX, pageY } = d3.event;
    const viewLeft = svgPos.left + window.pageXOffset;
    const viewTop = svgPos.top + window.pageYOffset;
    const { left, top, right, bottom } = p || {
      left: pageX,
      top: pageY,
      right: pageX,
      bottom: pageY,
    };
    return {
      left: left - viewLeft,
      top: top - viewTop,
      right: right - viewLeft,
      bottom: bottom - viewTop,
    };
  }
  updateMmdata(val?: Mdata | null) {
    // 不可变数据
    if (val) {
      mmdata.data = JSON.parse(JSON.stringify(val));
    }
    if (this.toRecord) {
      this.history.record(JSON.parse(JSON.stringify(mmdata.data)));
    }
    this.updateMindmap();
    this.toUpdate = false;
    this.$emit("change", [mmdata.getSource()]);
    let data = mmdata.data;
    let timer = setTimeout(() => {
      if (this.value) {
        this.save();
      }
      clearTimeout(timer);
    }, 200);
  }
  init() {
    // 绑定元素
    this.mindmapSvg = d3.select(this.$refs.svg);
    this.mindmapG = d3.select(this.$refs.content);
    this.mindmapG.style("opacity", 0);
    this.dummy = d3.select(this.$refs.dummy);
    // 绑定svg事件
    this.makeKeyboard(this.keyboard);
    this.mindmapSvg.on("contextmenu", () => {
      d3.event.preventDefault();
    });
    this.mindmapSvgZoom = this.zoom
      .on("zoom", () => {
        this.mindmapG.attr("transform", d3.event.transform);
      })
      .filter(
        () =>
          ((d3.event.ctrlKey && d3.event.type !== "mousedown") ||
            (this.spaceKey && d3.event.type !== "wheel") ||
            d3.event.type !== "touchmove") &&
          !d3.event.button
      ) // 开启双指捏合 空格键+左键可拖移
      .scaleExtent([0.1, 1.7]); // 缩放倍数: 0.1～8
    this.makeZoom(this.zoomable);

    // 获取初始化比例
    this.getPer();
  }
  initNodeEvent() {
    // 绑定节点事件
    this.makeDrag(this.draggable);
    this.makeNodeAdd(this.showNodeAdd);
    this.makeContextMenu(this.contextMenu);
  }
  // 事件
  makeKeyboard(val: boolean) {
    if (val) {
      document.addEventListener("keydown", this.svgKeyDown);
      document.addEventListener("keyup", this.svgKeyUp);
    } else {
      document.removeEventListener("keydown", this.svgKeyDown);
      document.removeEventListener("keyup", this.svgKeyUp);
    }
  }
  makeNodeAdd(val: boolean) {
    const fObject = this.mindmapG.selectAll("foreignObject") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    const gBtn = this.mindmapG.selectAll(".gButton") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    if (val) {
      const { mouseLeave, mouseEnter, gBtnClick } = this;
      fObject.on("mouseenter", mouseEnter).on("mouseleave", mouseLeave);
      gBtn
        .on("mouseenter", mouseEnter)
        .on("mouseleave", mouseLeave)
        .on("mousedown", gBtnClick);
    } else {
      fObject.on("mouseenter", null).on("mouseleave", null);
      gBtn.on("mouseenter", null).on("mouseleave", null).on("mousedown", null);
    }
  }
  makeContextMenu(val: boolean) {
    const selection = this.mindmapG.selectAll("foreignObject") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    //console.log(selection)

    if (val) {
      selection.on("contextmenu", this.fObjectRightClick);
    } else {
      selection.on("contextmenu", null);
    }
  }
  makeDrag(val: boolean) {
    const { mindmapG, dragged, fObjMousedown, dragended } = this;
    const selection = mindmapG.selectAll("foreignObject") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    const drag = d3
      .drag()
      .container(
        (d, i, n) => n[i].parentNode?.parentNode as d3.DragContainerElement
      ) as d3.DragBehavior<Element, FlexNode, FlexNode>;
    if (val) {
      selection.call(
        drag.on("start", fObjMousedown).on("drag", dragged).on("end", dragended)
      );
    } else {
      selection.call(drag.on("start", null).on("drag", null).on("end", null));
    }
  }
  makeZoom(val: boolean) {
    const { mindmapSvg, mindmapSvgZoom, zoom } = this;
    if (val) {
      mindmapSvg
        .call(mindmapSvgZoom)
        .on("dblclick.zoom", null)
        .on("wheel.zoom", () => {
          const { ctrlKey, deltaY, deltaX, x, y } = d3.event;
          d3.event.preventDefault();
          const current = d3.zoomTransform(this.$refs.svg);
          if (ctrlKey) {
            // 缩放
            const svgPos = this.$refs.svg.getBoundingClientRect();
            const px = svgPos.left + window.pageXOffset;
            const py = svgPos.top + window.pageYOffset;
            const k = current.k - deltaY * 0.02;
            zoom.scaleTo(mindmapSvg, k, [x - px, y - py]);
            this.getPer();
          } else {
            // 移动
            zoom.translateBy(mindmapSvg, -deltaX, -deltaY);
          }
        });
      // .on("touchmove.zoom", () => {
      //   const { deltaY, deltaX, x, y } = d3.event;
      //   alert("d3" + JSON.stringify(d3.event));
      //   d3.event.preventDefault();
      //   const current = d3.zoomTransform(this.$refs.svg);
      //   zoom.translateBy(mindmapSvg, -deltaX, -deltaY);
      // });
    } else {
      mindmapSvg.on(".zoom", null);
    }
  }
  // button事件
  undo() {
    if (this.canUndo) {
      this.toRecord = false;
      this.updateMmdata(this.history.undo());
    }
  }
  redo() {
    if (this.canRedo) {
      this.toRecord = false;
      this.updateMmdata(this.history.redo());
    }
  }





  downloadFile(content: string, filename: string) {
    const eleLink = document.createElement("a");
    eleLink.download = filename;
    eleLink.style.display = "none";
    // 字符内容转变成blob地址
    const blob = new Blob([content]);
    eleLink.href = URL.createObjectURL(blob);
    // 触发点击
    document.body.appendChild(eleLink);
    eleLink.click();
    // 然后移除
    document.body.removeChild(eleLink);
    window.parent.postMessage({ cmd: "pasteNode" }, "*");
    // 把blob传输给网页
    this.sendDownload(blob, filename);
    this.loadingEnd();
  }
  exportTo(val: any) {
    // 导出至
    const data = mmdata.getSource();
    let content = "";
    let filename = val.name;
    switch (this.selectedOption) {
      case 0: // JSON
        content = JSON.stringify(data, null, 2);
        break;
      case 2: // Markdown
        content = toMarkdown(data);
        break;
      default:
        break;
    }
    this.downloadFile(content, filename);
  }
  exportToFreeMind(val: any) {
    const xml = this.dataToFreeMind([mmdata.data]);
    this.downloadFile(xml, val.name);
  }

  dataToFreeMind(data: any) {
    let result = '<?xml version="1.0" encoding="UTF-8"?>\n';
    result += '<map version="0.9.0">\n';
    result += this.nodeToFreeMind(data);
    result += "</map>";
    return result;
  }

  nodeToFreeMind(nodes: any) {
    let result = "";
    nodes.forEach((node: any) => {
      result += `  <node TEXT="${node.name}"`;
      if (node.collapse) {
        result += ' COLLAPSED="true"';
      }
      if (node.left) {
        result += ' POSITION="left"'; // 添加左侧位置属性
      }
      result += ">\n";
      if (node.children && node.children.length) {
        result += this.nodeToFreeMind(node.children);
      }
      result += "  </node>\n";
    });
    return result;
  }
  async makeCenter() {
    // 居中
    await d3
      .transition()
      .end()
      .then(() => {
        const content = (this.$refs.content as SVGGElement).getBBox();
        const area = (this.$refs.svg as SVGGElement).getBBox();
        // const sx = (area.width - content.width) / 2;
        // const sy = (area.height - content.height) / 2;
        let minX = 150;
        if (window.innerWidth <= 767) {
          // let textLength = this.getByteLen(this.value[0].name);
          if (content.x < -108) {
            minX = 0;
          } else if (content.x < -108 && content.x > -44) {
            minX = 40;
          } else {
            minX = 80;
          }
        }
        let translatex = 0;
        if (mmdata.data.children && mmdata.data.children.length > 0) {
          translatex =
            window.innerWidth / 2 - area.width / 2 < minX ? minX : content.width / 2;
        }
        let translatey = -(-content.y - (content.height + content.y)) / 2;
        this.mindmapSvg.call(this.zoom.translateTo, translatex, translatey);
      });
  }
  getByteLen(val: any) {
    //传入一个字符串
    var len = 0;
    for (var i = 0; i < val.length; i++) {
      if (val[i].match(/[^\x00-\xff]/gi) != null)
        //全角
        len += 2;
      //如果是全角，占用两个字节
      else len += 1; //半角占用一个字节
    }
    return len;
  }
  async fitContent() {
    // 适应窗口大小
    await d3
      .transition()
      .end()
      .then(() => {
        const rect = (this.$refs.content as SVGGElement).getBBox();
        const div = this.$refs.mindmap;
        const multipleX = div.offsetWidth / rect.width;
        const multipleY = div.offsetHeight / rect.height;
        const multiple = Math.min(multipleX, multipleY);
        if (d3.zoomTransform(this.$refs.svg).k != multiple) {
          this.mindmapSvg
            .transition(this.easePolyInOut as any)
            .call(this.zoom.scaleTo, multiple);
        }
        let timer = setTimeout(() => {
          const content = (this.$refs.content as SVGGElement).getBBox();
          const area = (this.$refs.svg as SVGGElement).getBBox();
          let minX = 150;
          if (window.innerWidth <= 767) {
            // let textLength = this.getByteLen(this.value[0].name);
            if (content.x < -108) {
              minX = 0;
            } else if (content.x < -108 && content.x > -44) {
              minX = 40;
            } else {
              minX = 80;
            }
          }
          let translatex = 0;
          if (mmdata.data.children && mmdata.data.children.length > 0) {
            translatex =
              window.innerWidth / 2 - area.width / 2 < minX ? minX : content.width / 2;
          }
          let translatey = -(-content.y - (content.height + content.y)) / 2;
          this.mindmapSvg.call(this.zoom.translateTo, translatex, translatey);
          clearTimeout(timer);
        }, 500);
        this.getPer();
      });
  }
  async zoomNormal() {
    //刚打开显示1:1显示比例
    await d3
      .transition()
      .end()
      .then(() => {
        this.multiple = 1;

        this.mindmapSvg
          .call(this.zoom.translateTo, 0, 0)
          .transition(this.easePolyInOut as any)
          .call(this.zoom.scaleTo, this.multiple);
      });
  }

  async zoomMax() {
    // 适应窗口大小
    await d3
      .transition()
      .end()
      .then(() => {
        // const rect = (this.$refs.content as SVGGElement).getBBox()
        // const div = this.$refs.mindmap
        this.multiple = this.multiple + 1;

        this.mindmapSvg
          .call(this.zoom.translateTo, 0, 0)
          .transition(this.easePolyInOut as any)
          .call(this.zoom.scaleTo, this.multiple);
      });
  }

  // 数据操作
  add(dParent: Mdata, d: Data) {
    this.toRecord = true;
    const nd = mmdata.add(dParent.id, d);
    this.updateMmdata();
    return nd;
  }
  insert(dPosition: Mdata, d: Data, i = 0) {
    this.toRecord = true;
    const nd = mmdata.insert(dPosition.id, d, i);
    this.updateMmdata();
    return nd;
  }
  move(del: Mdata, insert?: Mdata, i = 0) {
    this.toRecord = true;
    mmdata.move(del.id, insert?.id, i);
    this.updateMmdata();
  }
  reparent(p: Mdata, d: Mdata) {
    this.toRecord = true;
    mmdata.reparent(p.id, d.id);
    this.updateMmdata();
  }
  addChildNode() {
    const sele = d3.select("#selectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    const seleNode = sele.node();
    if (seleNode) {
      const seleData = sele.data()[0];
      const seleDepth = seleData.depth;
      const im = seleData.data;
      const nd = this.add(im, { name: "" });
      if (nd) {
        this.editNew(nd, seleDepth + 1, seleNode.parentNode as Element);
      }
    }
  }

  addParentNode() {
    const sele = d3.select("#selectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    const seleNode = sele.node();
    if (seleNode && seleNode.parentNode) {
      const seleData = sele.data()[0];
      const seleDepth = seleData.depth;
      const im = seleData.data;
      if (im) {
        this.toRecord = true;
        const nd = mmdata.insert(im.id, { name: "" }, 1);
        if (nd) {
          mmdata.reparent(nd.id, im.id);
          this.updateMmdata();

          setTimeout(() => {
            const node = d3
              .selectAll(`g.node.depth_${seleDepth}`)
              .filter((b) => (b as FlexNode).data.id === nd.id)
              .node();
            this.selectNode(node as Element);
            this.editNode(node as Element);
          }, 100);
        }
      }
    }
  }

  addBrotherNode() {
    const sele = d3.select("#selectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    const seleNode = sele.node();
    if (seleNode && seleNode.parentNode) {
      const seleData = sele.data()[0];
      const seleDepth = seleData.depth;
      const im = seleData.data;
      if (im) {
        const nd = this.insert(im, { name: "" }, 1);
        if (nd) {
          this.editNew(nd, seleDepth, seleNode.parentNode as Element);
        }
      }
    }
  }

  del(s: Mdata | Mdata[]) {
    this.toRecord = true;
    if (Array.isArray(s)) {
      for (let i = 0; i < s.length; i++) {
        mmdata.del(s[i].id);
      }
    } else {
      mmdata.del(s.id);
    }
    this.updateMmdata();
  }
  delSelf(s: Mdata | Mdata[]) {
    this.toRecord = true;
    if (Array.isArray(s)) {
      const idArr = [];
      for (let i = 0; i < s.length; i++) {
        idArr.push(s[i].id);
      }
      mmdata.deleteSelf(idArr);
    } else {
      mmdata.deleteSelf(s.id);
    }
    this.updateMmdata();
  }
  updateName(d: Mdata, name: string) {
    if (d.name !== name) {
      // 有改变
      this.toRecord = true;
      const nd = mmdata.rename(d.id, name);
      this.updateMmdata();
      return nd;
    }
  }
  collapse(s: Mdata | Mdata[]) {
    this.toRecord = true;
    if (Array.isArray(s)) {
      const idArr = [];
      for (let i = 0; i < s.length; i++) {
        idArr.push(s[i].id);
      }
      mmdata.collapse(idArr);
    } else {
      mmdata.collapse(s.id);
    }
    this.updateMmdata();
  }
  expand(s: Mdata | Mdata[]) {
    this.toRecord = true;
    if (Array.isArray(s)) {
      const idArr = [];
      for (let i = 0; i < s.length; i++) {
        idArr.push(s[i].id);
      }
      mmdata.expand(idArr);
    } else {
      mmdata.expand(s.id);
    }
    this.updateMmdata();
  }
  onDayKeyDown() {
    d3.event.stopPropagation();
  }
  onDaysChange() {}

  nodeTextEditing() {
    const editNode = d3.select("#editing") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    const editNodeData = editNode.node();
    if (editNodeData)
      //正在编辑中，不需要保存，不然会丢失光标
      return true;
    else return false;
  }
  // 键盘
  svgKeyDown(event: any) {
    //const event = d3.event
    const keyName = event.key as string;
    // 针对导图的操作
    if (keyName === " " && !this.spaceKey) {
      this.spaceKey = true;
    }

    // if (this.viewMode) {
    //   //预览模式，其他不可用
    //   return;
    // }
    if (event.metaKey || event.ctrlKey) {
      if (keyName === "z") {
        // 撤销
        if (this.nodeTextEditing()) {
          return;
        }
        event.preventDefault();
        this.undo();
      } else if (keyName === "y") {
        // 重做
        event.preventDefault();
        this.redo();
      } else if (keyName === "Enter") {
        //console.log(event.ctrlKey+" "+keyName);
        let allCollapseFlag = true;
        let allNodes: Mdata[] = [];
        if (mmdata.data.children) {
          allCollapseFlag =
            mmdata.data.children.filter((d) => d.children && d.children.length > 0)
              .length > 0;
          for (let index = 0; index < mmdata.data.children.length; index++) {
            allNodes.push(mmdata.data.children[index]);
          }
        }

        if (allCollapseFlag) {
          this.collapse(allNodes);
        } else {
          this.expand(allNodes);
        }

        this.makeCenter();
      } else if (keyName === "c") {
        //复制
        if (this.nodeTextEditing())
          //正在编辑中，不需要保存，不然会丢失光标
          return;
        this.copyNode();
      } else if (keyName === "v") {
        //粘贴
        // event.preventDefault()
        window.parent.postMessage({ cmd: "pasteNode" }, "*");
        return;
        // this.pasteNode();
      } else if (keyName === "x") {
        //剪切
        if (this.nodeTextEditing())
          //正在编辑中，不需要保存，不然会丢失光标
          return;
        //event.preventDefault()
        this.cutNode();
      } else if (keyName === "s") {
        //保存
        event.preventDefault();
        this.save();
      }
    } else {
      // 针对节点的操作
      const sele = d3.select("#selectedNode") as d3.Selection<
        Element,
        FlexNode,
        Element,
        FlexNode
      >;
      const seleNode = sele.node();
      if (seleNode) {
        const seleData = sele.data()[0];
        const seleDepth = seleData.depth;
        const im = seleData.data;

        const pNode = seleNode.parentNode as Element;

        switch (keyName) {
          case "Tab": {
            event.preventDefault();
            const nd = this.add(im, { name: "" });
            if (nd) {
              this.editNew(nd, seleDepth + 1, pNode);
            }
            break;
          }
          case "Enter": {
            event.preventDefault();
            //console.log(event.ctrlKey+" "+keyName);

            if (pNode === this.$refs.content) {
              // 根节点enter时，等效tab
              const nd = this.add(im, { name: "" });
              if (nd) {
                this.editNew(nd, seleDepth + 1, pNode);
              }
            } else {
              const nd = this.insert(im, { name: "" }, 1);
              if (nd) {
                this.editNew(nd, seleDepth, pNode);
              }
            }
            break;
          }
          case "Backspace": {
            event.preventDefault();
            this.del(im);
            //选中节点
            var parentData = seleData.parent as FlexNode;
            if (parentData.data.children != null && parentData.data.children.length > 0) {
              var lastChildData =
                parentData.data.children[parentData.data.children.length - 1];
              //console.log(lastChildData)

              const node = d3
                .select(pNode)
                .selectAll(`g.node.depth_${parentData.depth + 1}`)
                .filter((b) => (b as FlexNode).data.id === lastChildData.id)
                .node();
              this.selectNode(node as Element);
            } else {
              this.selectNode(pNode);
            }

            break;
          }
          default:
            break;
        }
      } else {
        //多选的情况
        switch (keyName) {
          case "Backspace": {
            //多选删除
            const t: Mdata[] = [];
            (this.mindmapG.selectAll("g.multiSelectedNode") as d3.Selection<
              Element,
              FlexNode,
              Element,
              FlexNode
            >).each((d, i, n) => {
              t.push(d.data);
            });
            // console.log(t);
            event.preventDefault();
            if (t.length > 0) {
              this.del(t);
            }
          }
        }
      }
    }
  }
  svgKeyUp(event: any) {
    // 针对导图的操作

    if (event.key === " ") {
      this.spaceKey = false;
    }
  }
  divKeyDown(event: any) {
    //console.log(d3.event)
    if (d3.event.key === "Backspace") {
      d3.event.stopPropagation();
    }
    if (d3.event.key === "Enter" || d3.event.key === "Tab") {
      if (d3.event.altKey || d3.event.shiftKey) {
        return;
      }

      d3.event.preventDefault();
      d3.event.stopPropagation();

      const sele = d3.select("#editing") as d3.Selection<
        Element,
        FlexNode,
        Element,
        FlexNode
      >;
      this.updateNodeName();
      this.selectNode(sele.node() as Element);

      //setTimeout(() => { this.$refs.mindmap.focus() }, 300)
    }
  }
  // 节点操作
  updateNodeName() {
    // 文本编辑完成时
    const editP = document.querySelector(
      "#editing > foreignObject > div"
    ) as HTMLDivElement;
    window.getSelection()?.removeAllRanges(); // 清除选中
    if (editP == null) return;
    const editText = editP.innerText || "";
    this.mindmapG.select("g#editing").each((d, i, n) => {
      (n[i] as Element).removeAttribute("id");
      const nd = this.updateName(d.data, editText);
      if (nd) {
        this.$emit("updateNodeName", mmdata.getSource(nd.id), nd.id);
      }
    });
    editP.setAttribute("contenteditable", "false");
  }
  removeSelectedId() {
    // 清除选中节点
    //console.log('清除选中')
    const sele = document.getElementById("selectedNode");
    if (sele) {
      const resizeDiv = document.querySelector(
        "#selectedNode > foreignObject > .resize"
      ) as HTMLDivElement;
      resizeDiv.style.display = "none";

      sele.setAttribute("__click__", "0");
      sele.removeAttribute("id");
    }

    this.isSelectNode = false;
    this.isSelectNodeUnderline = "";
    this.showColorList = false;
    this.selectNodeColor = "#C2C2C2";
  }
  selectNode(n: Element) {
    // 选中节点
    this.removeMultiSelected();
    if (n.getAttribute("id") !== "selectedNode") {
      this.removeSelectedId();
      n.setAttribute("id", "selectedNode");
      const sele = d3.select("#selectedNode") as d3.Selection<
        Element,
        FlexNode,
        Element,
        FlexNode
      >;
      const seleData = sele.data()[0];
      if (seleData.depth != 0) {
        const resizeDiv = document.querySelector(
          "#selectedNode > foreignObject > .resize"
        ) as HTMLDivElement;
        resizeDiv.style.background = seleData.data.lineColor || "#E08370";
        resizeDiv.style.display = "block";
      }
      // 结束选择时判断是否有选中节点
      this.setHeightLight();

      // this.singleSelect = seleData.data;
      this.selectNodeColor = seleData.data.color as string;
    }
  }
  editNode(n: Element) {
    // 编辑节点
    this.removeSelectedId();
    n.setAttribute("id", "editing");
    const fObj = d3
      .select(n)
      .selectAll("foreignObject")
      .filter((a, b, c) => (c[b] as Element).parentNode === n) as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    this.focusNode(fObj);
    fObj.select("div").attr("contenteditable", "plaintext-only");
    const fdiv = document.querySelector("#editing > foreignObject > div");
    if (fdiv) {
      window.getSelection()?.selectAllChildren(fdiv);
    }
  }
  focusNode(fObj: d3.Selection<Element, FlexNode, Element | null, FlexNode | undefined>) {
    // 使节点处于可视区域
    const { k } = d3.zoomTransform(this.$refs.svg); // 放大缩小倍数
    const fObjPos = (fObj.node() as Element).getBoundingClientRect();
    if (fObjPos) {
      const svgPos = this.$refs.svg.getBoundingClientRect();

      const r = fObjPos.right - svgPos.right;
      const b = fObjPos.bottom - svgPos.bottom;
      const l = fObjPos.left - svgPos.left;
      const t = fObjPos.top - svgPos.top;
      const x = (r > 0 && r) || (l < 0 && l);
      const y = (b > 0 && b) || (t < 0 && t);

      // 保持节点可视
      if (x) {
        this.mindmapSvg.call(this.zoom.translateBy, -x / k, 0);
      }
      // if (window.innerHeight < 767 && b + window.innerHeight / 2 > 0) {
      //   let phoneb = window.innerHeight / 2;
      //   let num = -((b / k + phoneb + 50) / k);
      //   this.mindmapSvg.call(this.zoom.translateBy, 0, num);
      // } else if (y) {
      //   this.mindmapSvg.call(this.zoom.translateBy, 0, -y / k);
      // }
      if (y) {
        this.mindmapSvg.call(this.zoom.translateBy, 0, -y / k);
      }
    }
  }
  editNew(newD: Mdata, depth: number, pNode: Element) {
    // 聚焦新节点
    d3.transition()
      .end()
      .then(
        () => {
          const node = d3
            .select(pNode)
            .selectAll(`g.node.depth_${depth}`)
            .filter((b) => (b as FlexNode).data.id === newD.id)
            .node();

          this.editNode(node as Element);
        },
        (err) => {
          console.log(err);
        }
      );
  }
  fdivMouseDown() {
    const flag = d3.event.target.getAttribute("contenteditable");
    if (flag === "plaintext-only") {
      d3.event.stopPropagation(); // 防止触发drag、click
    }
  }
  fObjMousedown(d: FlexNode, i: number, n: ArrayLike<Element>) {
    const edit = document.getElementById("editing");
    let flag = 0;
    const clickedNode = n[i].parentNode as Element;
    if (edit && edit !== clickedNode) {
      const f = (d3
        .selectAll("foreignObject")
        .filter((d, i, n) => (n[i] as Element).parentNode === edit)
        .node() as Element).firstElementChild as HTMLElement;

      f.blur();
      flag = 1;
    }
    if (!edit || flag) {
      // 未在编辑
      this.selectNode(clickedNode);
    }
  }
  fObjectClick(d: FlexNode, i: number, n: ArrayLike<Element>) {
    // 两次单击进入编辑状态

    const sele = document.getElementById("selectedNode");
    const { dragFlag } = this;
    if (sele) {
      if (
        sele.getAttribute("__click__") === "1" &&
        n[i].parentNode === sele &&
        document.activeElement !== n[i].firstElementChild &&
        !dragFlag
      ) {
        this.editNode(sele);
        sele.setAttribute("__click__", "0");
      } else {
        sele.setAttribute("__click__", "1");
        if (!dragFlag) {
          this.$emit("click", mmdata.getSource(d.data.id), d.data.id);
        }
      }
    }
  }
  fObjectRightClick(d: FlexNode, i: number, n: ArrayLike<Element>) {
    const sele = document.getElementById("selectedNode");
    const edit = document.getElementById("editing");
    const clickedNode = n[i].parentNode as Element;
    const show = () => {
      // 显示右键菜单
      const pos = this.getViewPos();
      this.contextMenuX = pos.left;
      this.contextMenuY = pos.top;
      this.showContextMenu = true;
      this.clearSelection();
      setTimeout(() => {
        this.$refs.menu.focus();
      }, 300);
    };
    if (clickedNode.classList.contains("multiSelectedNode")) {
      const t: Mdata[] = [];
      (this.mindmapG.selectAll("g.multiSelectedNode") as d3.Selection<
        Element,
        FlexNode,
        Element,
        FlexNode
      >).each((d, i, n) => {
        t.push(d.data);
      });
      const collapseFlag =
        t.filter((d) => d.children && d.children.length > 0).length > 0;
      const expandFlag =
        t.filter((d) => d._children && d._children.length > 0).length > 0;
      this.contextMenuItems[5].disabled = !collapseFlag;
      this.contextMenuItems[6].disabled = !expandFlag;
      this.contextMenuTarget = t;
      show();
    } else if (clickedNode !== edit) {
      // 非正在编辑
      if (clickedNode !== sele) {
        // 选中
        this.selectNode(clickedNode);
      }
      const { data } = d;
      this.contextMenuItems[5].disabled = !(data.children && data.children.length > 0);
      this.contextMenuItems[6].disabled = !(data._children && data._children.length > 0);

      let allCollapseFlag = true;
      if (mmdata.data.children) {
        allCollapseFlag =
          mmdata.data.children.filter((d) => d.children && d.children.length > 0).length >
          0;
      }
      let allExpandFlag = true;
      if (mmdata.data.children) {
        allExpandFlag =
          mmdata.data.children.filter((d) => d._children && d._children.length > 0)
            .length > 0;
      }

      this.contextMenuItems[7].disabled = !allCollapseFlag;
      this.contextMenuItems[8].disabled = !allExpandFlag;
      this.contextMenuTarget = data;
      show();
    }
  }
  gBtnClick(a: FlexNode, i: number, n: ArrayLike<Element>) {
    // 添加子节点
    if ((n[i] as SVGElement).style.opacity === "1") {
      d3.event.stopPropagation();
      const d: FlexNode = d3.select(n[i].parentNode as Element).data()[0] as FlexNode;
      const newD = this.add(d.data, { name: "" });
      this.mouseLeave(d, i, n);
      if (newD) {
        this.editNew(newD, d.depth + 1, n[i].parentNode as Element);
      }
    }
  }
  clickMenu(key: string) {
    this.showContextMenu = false;
    const { contextMenuTarget } = this;
    switch (key) {
      case "add_parent":
        this.addParentNode();
        break;
      case "add":
        this.addChildNode();
        break;
      case "add_brother":
        this.addBrotherNode();
        break;
      case "delete":
        this.del(contextMenuTarget);
        break;
      case "delete_single":
        this.delSelf(contextMenuTarget);
        break;
      case "collapse":
        this.collapse(contextMenuTarget);
        break;
      case "expand":
        this.expand(contextMenuTarget);
        break;
      case "collapse_all":
        const collapseAll: Mdata[] = [];
        if (mmdata.data.children) {
          for (let index = 0; index < mmdata.data.children.length; index++) {
            collapseAll.push(mmdata.data.children[index]);
          }
        }
        this.collapse(collapseAll);
        break;
      case "expand_all":
        const expandAll: Mdata[] = [];
        if (mmdata.data.children) {
          for (let index = 0; index < mmdata.data.children.length; index++) {
            expandAll.push(mmdata.data.children[index]);
          }
        }
        this.expand(expandAll);
        break;
      default:
        break;
    }
    (this.$refs.svg as HTMLElement).focus();
    this.removeSelectedId();
  }
  // 悬浮事件
  mouseLeave(d: FlexNode, i: number, n: ArrayLike<Element>) {
    if ((n[i] as SVGElement).className.baseVal.includes("gButton")) {
      d3.select(n[i]).style("opacity", 0);
    } else {
      d3.selectAll("g.gButton")
        .filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode)
        .style("opacity", 0);
    }
  }
  mouseEnter(d: FlexNode, i: number, n: ArrayLike<Element>) {
    const flag = (d.data._children?.length || 0) > 0;
    if (!flag) {
      if ((n[i] as SVGElement).className.baseVal.includes("gButton")) {
        d3.select(n[i]).style("opacity", 1);
      } else {
        d3.selectAll("g.gButton")
          .filter((a, b, c) => (c[b] as Element).parentNode === n[i].parentNode)
          .style("opacity", 0.5);
      }
    }
  }
  // 拖拽
  draggedNodeRenew(draggedNode: Element, px: number, py: number, dura = 0, d: FlexNode) {
    const { path, renewOffset } = this;
    renewOffset(d, px, py);
    const targetY = d.dy + py; // x轴坐标
    const targetX = d.dx + px; // y轴坐标
    const tran = d3.transition().duration(dura).ease(d3.easePoly);

    d3.select(draggedNode)
      .transition(tran as any)
      .attr("transform", `translate(${targetY},${targetX})`);
    // 更新draggedNode与父节点的path
    d3.select(`path#path_${d.data.id}`)
      .transition(tran as any)
      .attr("d", (d) => path(d as FlexNode));
  }
  renewOffset(d: FlexNode, px: number, py: number) {
    // 更新偏移量
    d.px = px;
    d.py = py;
    if (d.children) {
      for (let index = 0; index < d.children.length; index += 1) {
        const dChild = d.children[index];
        this.renewOffset(dChild, px, py);
      }
    }
  }
  dragged(a: FlexNode, i: number, n: ArrayLike<Element>) {
    // 拖拽中【待完善】

    this.dragFlag = true;
    if (a.depth !== 0) {
      const { mindmapG, xSpacing, foreignX, foreignY } = this;
      const draggedNode = n[i].parentNode as Element;
      // 拖拽，相对a原本位置的偏移
      this.draggedNodeRenew(
        draggedNode,
        d3.event.y - a.y,
        d3.event.x - a.x,
        undefined,
        a
      );
      // 鼠标的坐标（相对于this.$refs.content）
      const t = d3.mouse(this.$refs.content as SVGGElement);
      const targetY = t[0]; // x轴坐标
      const targetX = t[1]; // y轴坐标

      // 计算others的坐标
      (mindmapG.selectAll("g.node") as d3.Selection<Element, FlexNode, Element, FlexNode>)
        .filter((d, i, n) => draggedNode !== n[i] && draggedNode.parentNode !== n[i])
        .each((d, i, n) => {
          const gNode = n[i];
          const rect = {
            // 其他gRect的坐标，以及gRect的宽高
            y: foreignX(d) + d.y, // foreignObject的x轴偏移
            x: foreignY(d) + d.x, // foreignObject的y轴偏移
            width: d.size[1] - xSpacing,
            height: d.size[0],
          };
          // 重叠触发矩形边框
          if (
            targetY > rect.y &&
            targetY < rect.y + rect.width &&
            targetX > rect.x &&
            targetX < rect.x + rect.height
          ) {
            gNode.setAttribute("id", "newParentNode");
          } else if (gNode.getAttribute("id") === "newParentNode") {
            gNode.removeAttribute("id");
          }
        });
    }
  }
  dragback(d: FlexNode, draggedNode: Element) {
    this.draggedNodeRenew(draggedNode, 0, 0, 1000, d);
  }
  dragended(d: FlexNode, i: number, n: ArrayLike<Element>) {
    const { dragback, reparent, fObjectClick } = this;
    const draggedNode = n[i].parentNode as Element;
    const newParentNode = document.getElementById("newParentNode");
    if (newParentNode) {
      // 建立新的父子关系
      newParentNode.removeAttribute("id");
      const newParentD = d3.select(newParentNode).data()[0] as FlexNode;
      reparent(newParentD.data, d.data);
    } else {
      const LR =
        d.data.id.split("-").length === 2 &&
        ((d.y > 0 && d.y + d.py < 0) || (d.y < 0 && d.y + d.py > 0)); // 左右节点变换
      const flag = LR
        ? (a: FlexNode) => a.data.left !== d.data.left
        : (a: FlexNode) => a.data.left === d.data.left;
      const draggedParentNode = d3.select(draggedNode.parentNode as Element);
      const draggedBrotherNodes = (draggedParentNode.selectAll(
        `g.depth_${d.depth}`
      ) as d3.Selection<Element, FlexNode, Element, FlexNode>).filter(
        (a, i, n) => draggedNode !== n[i] && flag(a)
      );
      if (!draggedBrotherNodes.nodes()[0]) {
        // 无兄弟节点时
        if (LR) {
          this.move(d.data);
        } else {
          dragback(d, draggedNode);
          fObjectClick(d, i, n);
        }
      } else {
        const a: {
          x0: number;
          x1: number;
          b1?: Mdata;
          n1?: Element;
          b0?: Mdata;
          n0?: Element;
        } = { x0: Infinity, x1: -Infinity };
        draggedBrotherNodes.each((b, i, n) => {
          if ((b.x > d.x || LR) && b.x > a.x1 && b.x < d.x + d.px) {
            // 找到新哥哥节点
            a.x1 = b.x;
            a.b1 = b.data;
            a.n1 = n[i];
          }
          if ((b.x < d.x || LR) && b.x < a.x0 && b.x > d.x + d.px) {
            // 找到新弟弟节点
            a.x0 = b.x;
            a.b0 = b.data;
            a.n0 = n[i];
          }
        });
        if (a.b0 || a.b1) {
          // 存在新兄弟节点时调换节点顺序
          const sdata = d.data;
          if (a.b0 && a.n0) {
            // 插入在兄弟节点前面
            this.move(sdata, a.b0);
            draggedNode.parentNode?.insertBefore(draggedNode, a.n0);
          } else if (a.b1 && a.n1) {
            // 插入在兄弟节点后面
            this.move(sdata, a.b1, 1);
            draggedNode.parentNode?.insertBefore(draggedNode, a.n1.nextSibling);
          }
        } else {
          dragback(d, draggedNode);
          fObjectClick(d, i, n);
        }
      }
    }
    this.dragFlag = false;
  }
  // 多选
  removeMultiSelected() {
    (this.mindmapG.selectAll("g.multiSelectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >).each((d, i, n) => {
      n[i].classList.remove("multiSelectedNode");
    });
  }
  multiSelectStart() {
    // 开始多选
    this.removeSelectedId();

    if (d3.event.button === 0) {
      // 左键
      this.removeMultiSelected();
      this.multiSeleFlag = true;
      const { mouse, getViewPos } = this;
      const vp = getViewPos();
      mouse.x0 = vp.left;
      mouse.y0 = vp.top;
    }
  }
  multiSelect() {
    // 多选中
    if (this.multiSeleFlag) {
      this.showSelectedBox = true;
      d3.event.preventDefault();
      const { mouse, getViewPos } = this;
      const vp = getViewPos();
      mouse.x1 = vp.left;
      mouse.y1 = vp.top;

      const { mindmapG, seleBox } = this;
      (mindmapG.selectAll("foreignObject") as d3.Selection<
        Element,
        FlexNode,
        Element,
        FlexNode
      >).each((d, i, n) => {
        const f = n[i];
        const g = f.parentNode as Element;
        const pos = getViewPos(f.getBoundingClientRect());
        const flag =
          pos.left < seleBox.right &&
          pos.bottom > seleBox.top &&
          pos.right > seleBox.left &&
          pos.top < seleBox.bottom;
        if (flag) {
          g.classList.add("multiSelectedNode");
        } else {
          g.classList.remove("multiSelectedNode");
        }
      });
    }
  }
  multiSelectEnd() {
    // 结束多选
    this.multiSeleFlag = false;
    this.showSelectedBox = false;
    const { mouse } = this;
    mouse.x0 = mouse.x1 = mouse.y0 = mouse.y1 = 0;

    // 结束选择时判断是否有选中节点
    this.setHeightLight();
  }
  // 绘制
  updateMindmap() {
    this.tree();
    this.getDTop();
    this.draw();
    this.initNodeEvent();
  }
  dKey(d: FlexNode) {
    return d.data.gKey;
  }
  gClass(d: FlexNode) {
    return `depth_${d.depth} node`;
  }
  gTransform(d: FlexNode) {
    return `translate(${d.dy},${d.dx})`;
  }
  foreignX(d: FlexNode) {
    const { xSpacing, foreignBorderWidth } = this;
    return (
      -foreignBorderWidth +
      (d.data.id !== "0"
        ? d.data.left
          ? -d.size[1] + xSpacing
          : 0
        : -(d.size[1] - xSpacing * 2) / 2)
    );
  }
  foreignY(d: FlexNode) {
    return -this.foreignBorderWidth + (d.data.id !== "0" ? -d.size[0] : -d.size[0] / 2);
  }
  foregnWidth(d: FlexNode) {
    return d.data.width && d.data.width > 0 ? d.data.width + "px" : "";
  }
  textDecoration(d: FlexNode) {
    return d.data.textDecoration ? d.data.textDecoration : "";
  }

  textColor(d: FlexNode) {
    return d.data.color ? d.data.color : "";
  }

  gBtnTransform(d: FlexNode) {
    const { xSpacing, gBtnSide } = this;
    let x =
      d.data.id === "0" ? (d.size[1] - xSpacing * 2) / 2 + 8 : d.size[1] - xSpacing + 8;
    if (d.data.left) {
      x = -x - gBtnSide;
    }
    return `translate(${x},${-gBtnSide / 2})`;
  }
  gBtnVisible(d: FlexNode) {
    return (d.data._children?.length || 0) <= 0 ? "visible" : "hidden";
  }
  gEllTransform(d: FlexNode) {
    const { xSpacing } = this;
    let x =
      d.data.id === "0" ? (d.size[1] - xSpacing * 2) / 2 + 6 : d.size[1] - xSpacing + 6;
    if (d.data.left) {
      x = -x - 16;
    }
    return `translate(${x},${0})`;
  }
  gEllVisible(d: FlexNode) {
    return (d.data._children?.length || 0) > 0 ? "visible" : "hidden";
  }
  pathId(d: FlexNode) {
    return `path_${d.data.id}`;
  }
  pathClass(d: FlexNode) {
    return `depth_${d.depth}`;
  }
  pathColor(d: FlexNode) {
    return d.data.lineColor || "white";
  }
  path(d: FlexNode) {
    const { xSpacing, link } = this;
    const temp =
      d.parent && d.parent.data.id === "0" ? -d.dy : d.data.left ? xSpacing : -xSpacing;
    const sourceX = temp - d.py;
    const sourceY = 0 - d.dx - d.px;
    let textWidth = d.size[1] - xSpacing;
    if (d.data.left) {
      textWidth = -textWidth;
    }

    return `${link({ source: [sourceX, sourceY], target: [0, 0] })}L${textWidth},${0}`;
  }
  nest(d: FlexNode, i: number, n: ArrayLike<Element>) {
    const { dKey, appendNode, updateNode, exitNode } = this;
    const dd = d.children || [];
    (d3
      .select(n[i])
      .selectAll(`g${dd[0] ? `.depth_${dd[0].depth}.node` : ""}`) as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >)
      .data(dd, dKey)
      .join(appendNode, updateNode, exitNode);
  }
  appendNode(enter: d3.Selection<d3.EnterElement, FlexNode, Element, FlexNode>) {
    const {
      resizeMouseDown,
      resizeMouseUp,
      expand,
      gEllTransform,
      gClass,
      gTransform,
      updateNodeName,
      onDaysChange,
      onDayKeyDown,
      divKeyDown,
      foreignY,
      gBtnTransform,
      pathId,
      pathClass,
      pathColor,
      path,
      nest,
      fdivMouseDown,
      foreignX,
      foregnWidth,
      textDecoration,
      textColor,
      gBtnSide,
      gBtnVisible,
      gEllVisible,
    } = this;
    const gNode = enter.append("g").attr("class", gClass).attr("transform", gTransform);

    const foreign = gNode.append("foreignObject").attr("x", foreignX).attr("y", foreignY);
    const foreignDiv = foreign
      .append("xhtml:div")
      .attr("contenteditable", false)
      .style("width", foregnWidth)
      .style("text-decoration", textDecoration)
      .style("color", textColor)
      .text((d: FlexNode) => d.data.name);

    // console.log("foregnWidth:" + foregnWidth);

    const resizeDiv = foreign
      .append("xhtml:span")
      .attr("class", "resize")
      .style("display", "none");
    resizeDiv.on("mousedown", resizeMouseDown).on("mouseup", resizeMouseUp);

    foreignDiv
      .on("blur", updateNodeName)
      .on("keydown", divKeyDown)
      .on("mousedown", fdivMouseDown);
    foreignDiv.each((d, i, n) => {
      const observer = new ResizeObserver((l) => {
        const t = l[0].target;
        const b1 = getComputedStyle(t).borderTopWidth;
        const b2 = getComputedStyle(t.parentNode as Element).borderTopWidth;
        const spacing = parseInt(b1, 10) + parseInt(b2, 10) || 0;
        foreign
          .filter((d: FlexNode, index: number) => i === index)
          .attr(
            "width",
            d.depth == 0
              ? l[0].contentRect.width + spacing * 2 + 22
              : l[0].contentRect.width + spacing * 2 + 2
          ) // div和foreign border
          .attr("height", l[0].contentRect.height + spacing * 2);
      });
      observer.observe(n[i] as Element);
    });

    const gBtn = gNode
      .append("g")
      .attr("class", "gButton")
      .attr("transform", gBtnTransform)
      .style("visibility", gBtnVisible);
    gBtn
      .append("rect")
      .attr("width", gBtnSide)
      .attr("height", gBtnSide)
      .attr("rx", 3)
      .attr("ry", 3);
    gBtn.append("path").attr("d", "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z");

    const ell = gNode
      .append("g")
      .attr("class", "gEllipsis")
      .attr("transform", gEllTransform)
      .style("visibility", gEllVisible)
      .classed("show", (d: FlexNode) => (d.data._children?.length || 0) > 0)
      .on("click", (d: FlexNode) => expand(d.data));
    ell
      .append("rect")
      .attr("x", -2)
      .attr("y", -6)
      .attr("width", 20)
      .attr("height", 14)
      .style("opacity", 0);
    ell
      .append("rect")
      .attr("x", 0)
      .attr("y", -2)
      .attr("width", 16)
      .attr("height", 4)
      .attr("rx", 2)
      .attr("ry", 2)
      .attr("class", "btn")
      .attr("stroke", pathColor)
      .attr("fill", pathColor);
    ell.append("circle").attr("cx", 4).attr("cy", 0).attr("r", 1);
    ell.append("circle").attr("cx", 8).attr("cy", 0).attr("r", 1);
    ell.append("circle").attr("cx", 12).attr("cy", 0).attr("r", 1);

    const enterData = enter.data();
    if (enterData.length) {
      if (enterData[0].data.id !== "0") {
        gNode
          .append("path")
          .attr("id", pathId)
          .attr("class", pathClass)
          .lower()
          .attr("stroke", pathColor)
          .attr("d", path);
      }
      gNode.each(nest);
    }

    gBtn.raise();
    foreign.raise();
    return gNode;
  }
  updateNode(update: d3.Selection<Element, FlexNode, Element, FlexNode>) {
    const {
      gEllTransform,
      gClass,
      gTransform,
      easePolyInOut,
      foreignY,
      gBtnTransform,
      pathId,
      pathClass,
      pathColor,
      path,
      nest,
      foreignX,
    } = this;
    update.interrupt().selectAll("*").interrupt();
    update
      .attr("class", gClass)
      .transition(easePolyInOut as any)
      .attr("transform", gTransform);

    update.each((d, k, m) => {
      const node = d3.select(m[k]) as d3.Selection<Element, FlexNode, null, undefined>;
      const foreign = node
        .selectAll("foreignObject")
        .filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .data([d]) // must rebind the children using selection.data to give them the new data.
        .attr("x", foreignX)
        .attr("y", foreignY);

      //修改为固定宽度 - dnanhui
      if (d.data.width && d.data.width > 0) {
        foreign.select("div").style("width", d.data.width + "px");
      }

      //添加删除线
      if (d.data.textDecoration) {
        //console.log(d.data.textDecoration)
        foreign.select("div").style("text-decoration", d.data.textDecoration);
      } else {
        foreign.select("div").style("text-decoration", "");
      }

      //添加字体颜色
      if (d.data.color) {
        foreign.select("div").style("color", d.data.color);
      } else {
        foreign.select("div").style("color", "");
      }

      foreign.select("div").text(d.data.name);

      node
        .select("path")
        .filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .attr("id", pathId(d))
        .attr("class", pathClass(d))
        .attr("stroke", pathColor(d))
        .transition(easePolyInOut as any)
        .attr("d", path(d));

      node.each(nest);

      const ellFlag = (d.data._children?.length || 0) > 0;

      node
        .selectAll("g.gButton")
        .filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .data([d])
        .attr("transform", gBtnTransform)
        .style("visibility", !ellFlag ? "visible" : "hidden")
        .raise();

      const ell = node
        .selectAll("g.gEllipsis")
        .filter((d, i, n) => (n[i] as Element).parentNode === m[k])
        .data([d])
        .attr("transform", gEllTransform)
        .classed("show", ellFlag)
        .style("visibility", ellFlag ? "visible" : "hidden");
      ell.select("rect.btn").attr("stroke", pathColor).attr("fill", pathColor);

      foreign.raise();
    });
    return update;
  }
  exitNode(exit: d3.Selection<Element, FlexNode, Element, FlexNode>) {
    exit.filter((d, i, n) => n[i].classList[1] === "node").remove();
  }
  draw() {
    // 生成svg
    const { dKey, mindmapG, appendNode, updateNode, exitNode } = this;
    const d = [this.root];

    (mindmapG.selectAll(`g${d[0] ? `.depth_${d[0].depth}.node` : ""}`) as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >)
      .data(d, dKey)
      .join(appendNode, updateNode, exitNode);
  }
  tree() {
    // 数据处理
    const { ySpacing } = this;
    const layout = flextree({ spacing: ySpacing });
    const yGap = mmdata.data.size[1] / 2;
    // left
    const tl = layout.hierarchy(mmdata.data, (d: Mdata) =>
      d.id.split("-").length === 1 ? d.children?.filter((d) => d.left) : d.children
    );
    layout(tl);
    tl.each((a: FlexNode) => {
      if (a.data.id !== "0") {
        a.y = -a.y + yGap;
      }
    });
    // right
    const tr = layout.hierarchy(mmdata.data, (d: Mdata) =>
      d.id.split("-").length === 1 ? d.children?.filter((d) => !d.left) : d.children
    );
    layout(tr);
    tr.each((a: FlexNode) => {
      if (a.data.id !== "0") {
        a.y = a.y - yGap;
      }
    }); // 往同个方向移动固定距离
    // all
    tr.children = tl.children
      ? tr.children
        ? tr.children.concat(tl.children)
        : tl.children
      : tr.children;
    tr.each((a: FlexNode) => {
      // x纵轴 y横轴 dx dy相对偏移
      if (a.data.id !== "0") {
        a.x += a.size[0] / 2;
      }
      a.dx = a.x - (a.parent ? a.parent.x : 0);
      a.dy = a.y - (a.parent ? a.parent.y : 0);
      a.px = 0;
      a.py = 0;
    });
    this.root = tr;
  }

  getDTop() {
    let t = this.root;
    while (t.children) {
      t = t.children[0];
    }
    this.dTop = t;
  }
  getSize(nodeData: Mdata, text: string, root = false) {
    const { dummy, xSpacing, minTextWidth, minTextHeight } = this;
    let textWidth = 0;
    let textHeight = 0;

    if (nodeData.width && nodeData.width > 0) {
      dummy
        .selectAll(".dummyText")
        .data([text])
        .enter()
        .append("div")
        .style("width", nodeData.width + "px")
        .text((d) => d)
        .each((d, i, n) => {
          textWidth = n[i].offsetWidth;
          textHeight = n[i].offsetHeight;
          n[i].remove(); // remove them just after displaying them
        });
    } else {
      dummy
        .selectAll(".dummyText")
        .data([text])
        .enter()
        .append("div")
        .text((d) => d)
        .each((d, i, n) => {
          textWidth = n[i].offsetWidth;
          textHeight = n[i].offsetHeight;
          n[i].remove(); // remove them just after displaying them
          // console.log("textWidth:" + textWidth);
        });
    }

    textWidth = Math.max(minTextWidth, root ? textWidth + 20 : textWidth);
    textHeight = Math.max(minTextHeight, textHeight);

    return [textHeight, textWidth + (root ? xSpacing * 2 : xSpacing)];
  }
  clearSelection() {
    // 清除右键触发的选中单词
    if (window.getSelection) {
      const sel = window.getSelection();
      sel?.removeAllRanges();
    }
  }

  resizeMouseDown() {
    d3.event.stopPropagation();
    //console.log("resizeMouseDown")
    const sele = d3.select("#selectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    this.resizeData = sele.data()[0].data;

    //console.log(this.resizeData.width)

    if (!this.resizeData.width || this.resizeData.width == 0) {
      this.dummy
        .selectAll(".dummyText")
        .data([this.resizeData.name])
        .enter()
        .append("div")
        .text((d) => d)
        .each((d, i, n) => {
          this.reiszeBufferWidth = n[i].offsetWidth + 5;
          n[i].remove(); // remove them just after displaying them
        });
    } else {
      this.reiszeBufferWidth = this.resizeData.width || 100;
    }

    //console.log(this.reiszeBufferWidth)
    this.reiszeBufferHeight = 0;
    this.resizeBufferPageX = d3.event.pageX;
    document.addEventListener("mousemove", this.resizeMouseMove);
    document.addEventListener("mouseup", this.resizeMouseUp);
  }

  resizeMouseMove(event: any) {
    //console.log(event)
    this.resizeData.width =
      this.reiszeBufferWidth + (event.pageX - this.resizeBufferPageX);

    // var sizeArr = this.getSize(this.resizeData,this.resizeData.name);
    // if(this.reiszeBufferHeight == 0){
    //     this.reiszeBufferHeight =  sizeArr[0]
    // }else if(this.reiszeBufferHeight == sizeArr[0]){
    //   console.log(this.reiszeBufferHeight +'  '+sizeArr[0])

    //   mmdata.resize(this.resizeData.id)
    //   const foreignDiv = d3.select('#selectedNode').select('foreignObject').select('div');
    //   foreignDiv.style("width",this.resizeData.width+"px")

    //   const sele = d3.select('#selectedNode') as d3.Selection<Element, FlexNode, Element, FlexNode>
    //   d3.select('#selectedNode').select('path').attr('d', this.path(sele.data()[0] as FlexNode))
    // }else if(this.reiszeBufferHeight != sizeArr[0]){
    //   this.reiszeBufferHeight = sizeArr[0]
    //   const nd = mmdata.resizeWidth(this.resizeData)

    //   mmdata.resize(this.resizeData.id)
    //   const foreignDiv = d3.select('#selectedNode').select('foreignObject').select('div');
    //   foreignDiv.style("width",this.resizeData.width+"px")

    //   const sele = d3.select('#selectedNode') as d3.Selection<Element, FlexNode, Element, FlexNode>
    //   d3.select('#selectedNode').select('path').attr('d', this.path(sele.data()[0] as FlexNode))

    //   this.updateMmdata()
    // }

    mmdata.resize(this.resizeData.id);
    this.updateMmdata();
  }

  resizeMouseUp(event: any) {
    //console.log("resizeMouseUp")
    if (event && event.stopPropagation) event.stopPropagation();
    document.removeEventListener("mousemove", this.resizeMouseMove);
    document.removeEventListener("mouseup", this.resizeMouseUp);

    const nd = mmdata.resizeWidth(this.resizeData);
    this.updateMmdata();
    this.reiszeBufferHeight = 0;
    //console.log(this.resizeData)
  }

  copyText(text: string) {
    var txtArea = document.createElement("textarea");
    txtArea.id = "txt";
    txtArea.style.position = "fixed";
    txtArea.style.top = "0";
    txtArea.style.left = "0";
    txtArea.style.opacity = "0";
    txtArea.value = text;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
      //console.log('Copying text command was ' + msg);
    } catch (err) {
      // console.log('Oops, unable to copy');
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  getPasteText(callback: Function) {
    navigator.clipboard
      .readText()
      .then((v) => {
        console.log("获取剪贴板成功：", v);
        let content = v;
        try {
          this.copyNodeData = JSON.parse(content === "" ? "[]" : content);
          callback();
        } catch (e) {
          console.log(e);
          this.copyNodeData = [];
        }
      })
      .catch((v) => {
        console.log("获取剪贴板失败: ", v);
      });
  }

  copyNode() {
    const sele = d3.select("#selectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    const seleNode = sele.node();
    //this.copyNodeData = []
    if (seleNode) {
      const seleData = sele.data()[0];
      //this.copyNodeData = [JSON.parse(JSON.stringify(seleData.data))]
      this.copyText(JSON.stringify([JSON.parse(JSON.stringify(seleData.data))]));
    } else {
      const t: Mdata[] = [];
      (this.mindmapG.selectAll("g.multiSelectedNode") as d3.Selection<
        Element,
        FlexNode,
        Element,
        FlexNode
      >).each((d, i, n) => {
        t.push(d.data);
      });

      const arr: Mdata[] = t.filter((item, index, list) => {
        let include = true;
        for (var num = 0; num < list.length; num++) {
          let children = list[num].children || [];
          if (children.indexOf(item) >= 0) {
            include = false;
          }
        }
        return include;
      });
      this.copyText(JSON.stringify(arr));
      //this.copyNodeData = arr
    }
  }
  countNodes(data: any) {
    let count = 0;
    data.forEach((node: any) => {
      count++; // 当前节点计数
      if (node.children && node.children.length > 0) {
        count += this.countNodes(node.children); // 递归计算子节点的数量
      }
    });
    return count;
  }
  pasteNode() {
    if (this.copyNodeData.length == 0) return;
    let count = this.countNodes([mmdata.data]) + this.countNodes(this.copyNodeData);
    let node_count = (this.power as { node_count: string }).node_count;
    if (node_count != "-1" && count > Number(node_count)) {
      window.parent.postMessage(
        { cmd: "copyLimitNodeCount", data: [mmdata.data], noInit: true },
        "*"
      );
      return;
    }
    const sele = d3.select("#selectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    const seleNode = sele.node();
    if (seleNode) {
      //(JSON.stringify(this.copyNodeData))
      const seleData = sele.data()[0];
      this.copyNodeData.forEach((itemData) => {
        mmdata.add(seleData.data.id, itemData);
      });
      this.copyNodeData = [];
      this.updateMmdata();
    }
    // this.getPasteText(() => {
    //   if (this.copyNodeData.length == 0) return;
    //   // console.log(this.copyNodeData)
    //   const sele = d3.select("#selectedNode") as d3.Selection<
    //     Element,
    //     FlexNode,
    //     Element,
    //     FlexNode
    //   >;
    //   const seleNode = sele.node();
    //   if (seleNode) {
    //     //(JSON.stringify(this.copyNodeData))
    //     const seleData = sele.data()[0];
    //     this.copyNodeData.forEach((itemData) => {
    //       mmdata.add(seleData.data.id, itemData);
    //     });
    //     this.copyNodeData = [];
    //     this.updateMmdata();
    //   }
    // });
  }

  cutNode() {
    const sele = d3.select("#selectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    const seleNode = sele.node();
    //this.copyNodeData = []
    if (seleNode) {
      const seleData = sele.data()[0];
      this.copyText(JSON.stringify([seleData.data]));
      mmdata.del(seleData.data.id);
      this.updateMmdata();
    } else {
      const t: Mdata[] = [];
      (this.mindmapG.selectAll("g.multiSelectedNode") as d3.Selection<
        Element,
        FlexNode,
        Element,
        FlexNode
      >).each((d, i, n) => {
        t.push(d.data);
      });

      const arr: Mdata[] = t.filter((item, index, list) => {
        let include = true;
        for (var num = 0; num < list.length; num++) {
          let children = list[num].children || [];
          if (children.indexOf(item) >= 0) {
            include = false;
          }
        }
        return include;
      });
      this.copyText(JSON.stringify(arr));
      arr.forEach((itemData) => {
        mmdata.del(itemData.id);
      });
      this.updateMmdata();
    }
  }

  addWatch() {
    this.$watch(
      "value",
      (newVal) => {
        //console.log(newVal)

        if (newVal.length === 0) return;
        if (this.toUpdate) {
          // mmdata = new ImData(newVal[0], this.getSize);
          mmdata = new ImData(newVal[0], this.power, this.getSize);
          this.updateMmdata();
        } else {
          this.toUpdate = true;
        }
      },
      { immediate: true, deep: true }
    );

    clearInterval(this.saveTimer);
    this.autoSaveTimer();

    this.$watch(
      "history",
      (newVal) => {
        // console.log(newVal)
        //this.save()
      },
      { immediate: true, deep: true }
    );
  }
  async mounted() {
    this.init();
    this.mindmapSvg.on("mousedown", this.multiSelectStart);
    this.mindmapSvg.on("mousemove", this.multiSelect);
    this.mindmapSvg.on("mouseup", this.multiSelectEnd);
    this.addWatch();
    await this.makeCenter();

    if (this.zoomFit) {
      this.mindmapG.style("opacity", 0);
      setTimeout(() => {
        this.fitContent();
        this.mindmapG.style("opacity", 1);
      }, 500);
    } else {
      await this.zoomNormal();
      this.mindmapG.style("opacity", 1);
    }
    let that = this;
    window.addEventListener("message", function (event) {
      if (event.data && event.data.cmd) {
        if (event.data.cmd == "copyDataPasteNode") {
          that.copyNodeData = event.data.copyData;
          that.pasteNode();
        }
        if (event.data.cmd == "undo") {
          that.undo();
        }
        if (event.data.cmd == "redo") {
          that.redo();
        }
        if (event.data.cmd == "enmax" || event.data.cmd == "enmin") {
          that.sizeMethod = {
            method: event.data.cmd,
          };
        }
        if (event.data.cmd == "download") {
          if (event.data.type == "markdown" || event.data.type == "json") {
            that.selectedOption = event.data.type == "json" ? 0 : 2;
            that.exportTo(event.data);
          } else if (event.data.type == "freemind") {
            that.exportToFreeMind(event.data);
          } else if (event.data.type == "image") {
            that.$nextTick(() => {
              let mindmap = document.getElementById("mindmap") as HTMLElement;
              let svg = that.$refs.svg;
              let newZoom = d3.zoomTransform(svg);
              let bbox = (svg as SVGGElement).getBBox();
              let contentDom = (that.$refs.content as SVGGElement).getBBox();
              let newMindmap = mindmap.cloneNode(true) as HTMLElement;
              if (newMindmap) {
                newMindmap.style.width = (bbox.width / newZoom.k) * 3 + "px";
                newMindmap.style.height = (bbox.height / newZoom.k) * 3 + "px";
                newMindmap.style.position = "fixed";
                newMindmap.style.top = "0px";
                newMindmap.style.left = "0px";
                newMindmap.style.zIndex = "-1";
                let newContent: Element | null = newMindmap.querySelector("#content");
                let content = document.getElementById("content") as HTMLElement;
                let childNodes = content.getElementsByClassName("depth_0 node")[0]
                  .childNodes;
                let clientWidth = 0;
                for (let i = 0; i < childNodes.length; i++) {
                  if (childNodes[i] && childNodes[i].nodeName == "foreignObject") {
                    let node = childNodes[i] as HTMLElement;
                    clientWidth = node.clientWidth;
                  }
                }
                let x =
                  ((bbox.width / newZoom.k) * 3 - (bbox.width / newZoom.k) * 2.6) / 2;
                if (newContent) {
                  newContent.setAttribute(
                    "transform",
                    `translate(${x + (clientWidth / 2) * 2.6 + 36},${
                      -contentDom.y * 3 + 50
                    }) scale(2.6)`
                  );
                }
                document.body.appendChild(newMindmap);
                html2canvas(newMindmap, {
                  useCORS: true, // 允许CORS跨域
                  foreignObjectRendering: true,
                  allowTaint: true,
                }).then((canvas) => {
                  if (event.data.noVip && event.data.watermark) {
                    // 创建一个新的Canvas来添加水印
                    const watermarkedCanvas = document.createElement("canvas");
                    const ctx = watermarkedCanvas.getContext("2d");

                    // 设置新Canvas的尺寸
                    watermarkedCanvas.width = canvas.width;
                    watermarkedCanvas.height = canvas.height;

                    // 将原始Canvas内容绘制到新Canvas上
                    if (ctx) {
                      ctx.drawImage(canvas, 0, 0);
                    }
                    const watermarkImage = new Image();
                    watermarkImage.crossOrigin = "Anonymous"; // 如果需要跨域图片
                    watermarkImage.onload = () => {
                      if (ctx) {
                        let width =
                          watermarkedCanvas.width / 2 < 100
                            ? 100
                            : watermarkedCanvas.width / 2;
                        let height =
                          (width / watermarkImage.width) * watermarkImage.height;
                        ctx.drawImage(
                          watermarkImage,
                          watermarkedCanvas.width / 2 - width / 2,
                          watermarkedCanvas.height / 2 - height / 2,
                          width,
                          height
                        );
                      }
                      watermarkedCanvas.toBlob(function (blob) {
                        if (blob) {
                          const url = URL.createObjectURL(blob);
                          const a = document.createElement("a");
                          a.href = url;
                          a.download = event.data.name;
                          document.body.appendChild(a);
                          a.click();
                          document.body.removeChild(a);
                          URL.revokeObjectURL(url); // 清理内存
                          // 把blob传输给网页
                          that.sendDownload(blob, event.data.name);
                          that.loadingEnd();
                        }
                      }, "image/png");
                    };
                    watermarkImage.src = event.data.watermark; // 替换为你的水印图片URL
                  } else {
                    canvas.toBlob(function (blob) {
                      if (blob) {
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = event.data.name;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        document.body.removeChild(newMindmap);
                        URL.revokeObjectURL(url); // 清理内存
                        // 把blob传输给网页
                        that.sendDownload(blob, event.data.name);
                        that.loadingEnd();
                      }
                    }, "image/png");
                  }
                });
              }
            });
          }
        }
        if (event.data.cmd == "makeZoom") {
          that.makeCenter();
        }
      }
    });
  }
  sendDownload(blob: Blob, name: string) {
    window.parent.postMessage(
      {
        cmd: "downloadUrl",
        url: blob,
        name: name,
      },
      "*"
    );
  }

  // loading结束
  loadingEnd() {
    window.parent.postMessage(
      {
        cmd: "loadingEnd",
      },
      "*"
    );
  }

  //返回
  back() {
    if (this.history.canUndo) {
      //console.log("back save")
      window.parent.postMessage({ cmd: "back", data: this.value, noInit: true }, "*");
    } else {
      //console.log("back")
      window.parent.postMessage({ cmd: "back" }, "*");
    }
  }

  //预览
  preview() {
    window.parent.postMessage({ cmd: "preview", data: this.value, noInit: true }, "*");
  }

  //协作
  cooperation() {
    window.parent.postMessage({ cmd: "cooperation" }, "*");
  }

  //分享
  share() {
    window.parent.postMessage({ cmd: "share" }, "*");
  }
  //保存
  save(autoSave: boolean = false) {
    window.parent.postMessage(
      {
        cmd: "save",
        data: this.value,
        autoSave: autoSave,
        noInit: true,
        history: { canUndo: this.canUndo, canRedo: this.canRedo },
      },
      "*"
    );
  }

  //查看历史版本
  versions() {
    window.parent.postMessage({ cmd: "versions" }, "*");
  }

  //导出
  exportMind() {
    window.parent.postMessage({ cmd: "export" }, "*");
  }

  scale_move(e: number) {
    const current = d3.zoomTransform(this.$refs.svg);
    let k = current.k; // 表示当前缩放量
    //console.log({k})

    var x = d3.scaleLinear().domain([0, 100]).range([0.1, 8]);

    this.zoom.scaleTo(this.mindmapSvg, x(e));
  }

  getPer() {
    const current = d3.zoomTransform(this.$refs.svg);
    const k = current.k; // 表示当前缩放量
    const y = d3.scaleLinear().domain([0.1, 8]).range([0, 100]);
    this.init_per = y(k);
    // console.log(this.init_per)
  }

  setLineThrough() {
    // 设置删除线
    const sele = d3.select("#selectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    if (sele.node()) {
      // 单选
      let seleData = sele.data()[0];
      seleData.data.textDecoration == "line-through"
        ? (seleData.data.textDecoration = "")
        : (seleData.data.textDecoration = "line-through");
      this.isSelectNodeUnderline = seleData.data.textDecoration;
    } else {
      // 多选
      let arr: Mdata[] = [];
      (this.mindmapG.selectAll("g.multiSelectedNode") as d3.Selection<
        Element,
        FlexNode,
        Element,
        FlexNode
      >).each((d, i) => {
        arr.push(d.data);
      });
      if (arr.every((item) => item.textDecoration == "line-through")) {
        arr.forEach((el) => {
          el.textDecoration = "";
        });
      } else {
        arr.forEach((el) => {
          el.textDecoration = "line-through";
        });
      }
      this.isSelectNodeUnderline = "";
      this.isSelectNode = false;
    }
    this.updateMmdata();
  }

  openColor() {
    if (!this.isSelectNode) return;
    // 设置颜色值
    this.showColorList = !this.showColorList;
  }

  setColor(color: string) {
    if (!this.isSelectNode) return;
    // const sele = d3.select('#selectedNode') as d3.Selection<Element, FlexNode, Element, FlexNode>
    // let seleData = sele.data()[0]
    // seleData.data.color = color
    // this.showColorList = false
    // this.selectNodeColor = color
    // this.updateMmdata()

    const sele = d3.select("#selectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    if (sele.node()) {
      // 单选
      let seleData = sele.data()[0];
      seleData.data.color = color;
      this.showColorList = false;
    } else {
      // 多选
      let arr: Mdata[] = [];
      (this.mindmapG.selectAll("g.multiSelectedNode") as d3.Selection<
        Element,
        FlexNode,
        Element,
        FlexNode
      >).each((d, i) => {
        arr.push(d.data);
      });
      arr.forEach((el) => {
        el.color = color;
      });
      // this.isSelectNode = false
    }
    this.selectNodeColor = color;
    this.updateMmdata();
  }

  setHeightLight() {
    const sele = d3.select("#selectedNode") as d3.Selection<
      Element,
      FlexNode,
      Element,
      FlexNode
    >;
    const multiSelectedNode = this.mindmapG.selectAll(
      "g.multiSelectedNode"
    ) as d3.Selection<Element, FlexNode, Element, FlexNode>;
    if (sele.node() || multiSelectedNode.node()) {
      this.isSelectNode = true;
      if (sele.node()) {
        this.isSelectNodeUnderline = sele.data()[0].data.textDecoration as string;
      } else {
        let arr: Mdata[] = [];
        (this.mindmapG.selectAll("g.multiSelectedNode") as d3.Selection<
          Element,
          FlexNode,
          Element,
          FlexNode
        >).each((d, i) => {
          arr.push(d.data);
        });
        if (arr.every((item) => item.textDecoration == "line-through")) {
          this.isSelectNodeUnderline = "line-through";
        } else {
          this.isSelectNodeUnderline = "";
        }
        if (arr.every((item) => item.color == arr[0].color)) {
          this.selectNodeColor = arr[0].color as string;
        }
      }
    }
  }

  autoSaveTimer() {
    this.saveTimer = setInterval(() => {
      if (this.nodeTextEditing())
        //正在编辑中，不需要保存，不然会丢失光标
        return;

      const selectedNode = d3.select("#selectedNode") as d3.Selection<
        Element,
        FlexNode,
        Element,
        FlexNode
      >;
      const selectedNodeData = selectedNode.node();
      if (selectedNodeData)
        //有选中节点，不需要保存，不然会丢失光标
        return;

      const multiSelectedNode = this.mindmapG.selectAll(
        "g.multiSelectedNode"
      ) as d3.Selection<Element, FlexNode, Element, FlexNode>;
      const multiSelectedNodeData = multiSelectedNode.node();
      if (multiSelectedNodeData)
        //有多选节点，不需要保存，不然会丢失光标
        return;

      // if (this.history.canUndo) {
      //   this.save(true);
      // }
    }, 5000);
  }
}
